import React from "react";
import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

interface IColumnTabWithMapperProps {
  value: number | string;
  mapperId: number;
}
export default function ColumnTabWithMapper({
  value,
  mapperId,
}: IColumnTabWithMapperProps) {
  const { data } = useGetDatasetMapperData(mapperId);
  
  if (data && data.mappings) {
    return <>{data.mappings[value]}</>
  }

  return <>{value}</>;
}
